export const CUSTOM_ATTRIBUTE_KEYS = {
  hostname: "hostname",
  ipAddress: "ipAddress",
  dnsName: "dnsName",
  os: "os",
  osVersion: "osVersion",
  owner: "owner",
  cloudProvider: "cloudProvider",
  cloudAccountId: "cloudAccountId",
  cloudResourceType: "cloudResourceType",
  imageRepo: "imageRepo",
  registry: "registry",
  cluster: "cluster",
  namespace: "namespace",
  cloudResource: "cloudResource",
  region: "region",
  runtime: "runtime",
  architecture: "architecture",
  vpcId: "vpcId",
  role: "role",
  version: "version",
  storageType: "storageType",
};
